import { KnowledgeBaseList } from './KnowledgeBaseList/knowledge-base-list';

export const KnowledgeTab = () => {
  return (
    <div className="knowledge-management-layout">
      <KnowledgeBaseList />
    </div>
  );
};
